import { CommonModule } from '@angular/common';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ChatService } from '../../../services/chat.service';

@Component({
  selector: 'app-restart-popup',
  templateUrl: './restart-popup.component.html',
  styleUrls: ['./restart-popup.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class RestartPopupComponent implements OnInit {
  @Input() message: string = '';
  @Input() showCancel: boolean = true;
  @Output() onRestart: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  ngOnInit() {}

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  onRestartClick() {
    this.onRestart.emit();
  }

  onCancelClick() {
    this.onClose.emit();
  }
}
